// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2Kpgu","title":"ClientCherryInfo_title__2o_1m","itemText":"ClientCherryInfo_itemText__1plmt"};